// Group only links already permitted by the role, entitlement and module filters.
export function staffHeaderNavigation(links, duties) {
  void links;
  const assigned = key => duties.includes(key) || duties.includes('SUPERVISOR');
  const page = (key,label,to) => assigned(key) ? [{label,to}] : [];
  const group=(label,children)=>children.length>1?[{label,children}]:children;
  const orders=[
    ...page('QUEUE','Queue & Orders','/dashboard/queue'),
    ...page('BEARER','Order taking (Bearer)','/dashboard/workspace/take-order'),
    ...page('APPROVAL','Order approver · Dishes','/dashboard/workspace?duty=APPROVAL'),
    ...page('TAKEAWAY','Takeaway counter','/dashboard/workspace?duty=TAKEAWAY')
  ];
  const bookings=[
    ...(assigned('BEARER') ? page('ROOM_PREORDER','Booking','/dashboard/pre-orders') : []),
    ...(assigned('BEARER') ? page('ROOM_PREORDER','View Bookings','/dashboard/bookings') : []),
    ...(assigned('BEARER') ? page('BOOKING_DELIVERY','Booking Delivery','/dashboard/booking-delivery') : [])
  ];
  return [
    ...group('Order',orders),
    ...page('BILLING','Billing','/dashboard/workspace?duty=BILLING'),
    ...page('KITCHEN','Chef / Kitchen','/dashboard/kitchen'),
    ...group('Liquor',[
      ...page('LIQUOR','Liquor counter','/dashboard/liquor'),
      ...page('LIQUOR_APPROVAL','Order approver · Liquor','/dashboard/liquor')
    ]),
    ...page('SELF_SERVICE','Self Service','/dashboard/workspace?duty=SELF_SERVICE'),
    ...page('HOTEL_RECEPTION','Hotel Reception','/dashboard/workspace?duty=HOTEL_RECEPTION'),
    ...group('Booking',bookings),
    ...group('Delivery',[
      ...page('DISPATCH','Delivery dispatch','/dashboard/workspace?duty=DISPATCH'),
      ...page('DELIVERY','Delivery rider','/dashboard/workspace?duty=DELIVERY')
    ]),
    ...group('Stock & Management',[
      ...page('PURCHASE_STOCK','Purchase & Stock Management','/dashboard/purchase-stock'),
      ...page('PURCHASES','Purchases','/dashboard/purchase-stock?tab=PURCHASE'),
      ...page('EXPENDITURE','Daily expenditure & issues','/dashboard/purchase-stock?tab=ISSUE')
    ]),
    ...page('BEARER','Cash in hand','/dashboard/cash-in-hand')
  ];
}

export function groupDashboardNavigation(links) {
  const orderPaths = ['/dashboard/queue', '/dashboard/liquor', '/dashboard/bookings'];
  const modulePaths = ['/dashboard/self-service', '/dashboard/delivery', '/dashboard/tables', '/dashboard/rooms', '/dashboard/pre-orders', '/dashboard/booking-delivery', '/dashboard/departments', '/dashboard/purchase-stock'];
  const reportPaths = ['/dashboard/shop-reports', '/dashboard/shop-reports/feedback', '/dashboard/shop-finance', '/dashboard/stock-reports', '/dashboard/cash-report'];
  const labels = {
    '/dashboard/shop-finance': 'Finance & settlements',
    '/dashboard/pre-orders': 'Booking', '/dashboard/bookings': 'View Bookings',
    '/dashboard/menu': 'Menu', '/dashboard/queue': 'Queue & Orders', '/dashboard/liquor': 'Liquor Order',
    '/dashboard/settings': 'Settings', '/dashboard/staff': 'Users',
    '/dashboard/rooms': 'Rooms', '/dashboard/tables': 'Tables'
  };
  const renamed = links.map(link => ({ ...link, label: labels[link.to] || link.label }));
  const group = (label, paths) => ({ label, children: paths.map(path => renamed.find(link => link.to === path)).filter(Boolean) });
  const orders = group('Orders', orderPaths), modules = group('Modules', modulePaths), reports = group('Reports', reportPaths);
  const groupedPaths = new Set([...orderPaths, ...modulePaths, ...reportPaths]);
  const main = renamed.filter(link => !groupedPaths.has(link.to));
  // Insert each group in its requested position without inventing any destinations.
  const kitchenIndex = main.findIndex(link => link.to === '/dashboard/kitchen');
  const settingsIndex = main.findIndex(link => link.to === '/dashboard/settings');
  const insertAt = kitchenIndex >= 0 ? kitchenIndex : settingsIndex >= 0 ? settingsIndex : main.length;
  if (orders.children.length) main.splice(insertAt, 0, orders);
  const kitchenPosition = main.findIndex(link => link.to === '/dashboard/kitchen');
  const settingsPosition = main.findIndex(link => link.to === '/dashboard/settings');
  if (modules.children.length) main.splice(kitchenPosition >= 0 ? kitchenPosition + 1 : settingsPosition >= 0 ? settingsPosition : main.length, 0, modules);
  if (reports.children.length) {
    const usersPosition = main.findIndex(link => link.to === '/dashboard/staff');
    main.splice(usersPosition >= 0 ? usersPosition : main.length, 0, reports);
  }
  return main;
}

export function staffLandingPath(duties=[]){
 if(duties.some(key=>['QUEUE','SUPERVISOR'].includes(key)))return '/dashboard/queue';
 const nav=staffHeaderNavigation([],duties);
 const first=nav.flatMap(link=>link.children||[link]).find(link=>!['/dashboard/workspace','/dashboard/cash-in-hand'].includes(link.to));
 return first?.to || '/dashboard/workspace';
}

export function staffCanVisit(path,search='',duties=[]){
 const has=key=>duties.includes(key)||duties.includes('SUPERVISOR');
 if(path==='/dashboard'||path==='/dashboard/')return true;
 if(path==='/dashboard/workspace'){
  const duty=new URLSearchParams(search).get('duty');
  return !duty||(['APPROVAL','BILLING','TAKEAWAY','SELF_SERVICE','HOTEL_RECEPTION','DISPATCH','DELIVERY'].includes(duty)&&has(duty));
 }
 if(path==='/dashboard/workspace/take-order')return has('BEARER')||has('TAKEAWAY');
 if(path==='/dashboard/workspace/approval-order')return has('APPROVAL');
 if(path.startsWith('/dashboard/purchase-stock')){
  const tab=new URLSearchParams(search).get('tab');
  if(tab==='PURCHASE'||path.includes('/entries/purchase/'))return has('PURCHASES');
  if(tab==='ISSUE'||path.includes('/entries/expenditure/'))return has('EXPENDITURE');
  return ['PURCHASE_STOCK','PURCHASES','EXPENDITURE'].some(has);
 }
 const requirements={
  '/dashboard/queue':['QUEUE'],'/dashboard/cash-in-hand':['BEARER'],
  '/dashboard/kitchen':['KITCHEN'],'/dashboard/liquor':['LIQUOR','LIQUOR_APPROVAL'],
  '/dashboard/pre-orders':['BEARER','ROOM_PREORDER'],'/dashboard/bookings':['BEARER','ROOM_PREORDER'],
  '/dashboard/booking-delivery':['BEARER','BOOKING_DELIVERY']
 };
 const required=requirements[path.replace(/\/$/,'')];
 if(!required)return false;
 return path.replace(/\/$/,'')==='/dashboard/liquor'?required.some(has):required.every(has);
}
